"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwsRegion = void 0;
var AwsRegion;
(function (AwsRegion) {
    AwsRegion["AfSouth1"] = "af-south-1";
    AwsRegion["ApEast1"] = "ap-east-1";
    AwsRegion["ApNortheast1"] = "ap-northeast-1";
    AwsRegion["ApNortheast2"] = "ap-northeast-2";
    AwsRegion["ApNortheast3"] = "ap-northeast-3";
    AwsRegion["ApSouth1"] = "ap-south-1";
    AwsRegion["ApSouth2"] = "ap-south-2";
    AwsRegion["ApSoutheast1"] = "ap-southeast-1";
    AwsRegion["ApSoutheast2"] = "ap-southeast-2";
    AwsRegion["ApSoutheast3"] = "ap-southeast-3";
    AwsRegion["CaCentral1"] = "ca-central-1";
    AwsRegion["CnNorth1"] = "cn-north-1";
    AwsRegion["CnNorthwest1"] = "cn-northwest-1";
    AwsRegion["EuCentral1"] = "eu-central-1";
    AwsRegion["EuNorth1"] = "eu-north-1";
    AwsRegion["EuSouth1"] = "eu-south-1";
    AwsRegion["EuSouth2"] = "eu-south-2";
    AwsRegion["EuWest1"] = "eu-west-1";
    AwsRegion["EuWest2"] = "eu-west-2";
    AwsRegion["EuWest3"] = "eu-west-3";
    AwsRegion["IsobEast1"] = "isob-east-1";
    AwsRegion["IsoEast1"] = "iso-east-1";
    AwsRegion["IsoWest1"] = "iso-west-1";
    AwsRegion["MeCentral1"] = "me-central-1";
    AwsRegion["MeSouth1"] = "me-south-1";
    AwsRegion["SaEast1"] = "sa-east-1";
    AwsRegion["UsEast1"] = "us-east-1";
    AwsRegion["UsEast2"] = "us-east-2";
    AwsRegion["UsGovEast1"] = "us-gov-east-1";
    AwsRegion["UsGovWest1"] = "us-gov-west-1";
    AwsRegion["UsWest1"] = "us-west-1";
    AwsRegion["UsWest2"] = "us-west-2";
})(AwsRegion || (exports.AwsRegion = AwsRegion = {}));
//# sourceMappingURL=aws.js.map